import { action } from '@ember/object';
import SettingsCustomersBaseController from '../base';

export default class SettingsCustomersCustomerEditController extends SettingsCustomersBaseController {
  @action
  cancel() {
    // Rollback changes to avoid persisting unsaved changes
    this.model.rollbackAttributes();
    this.goToListPage();
  }
}
